import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import ForgotPasswordStore from '../../stores/ForgotPasswordStore';
import FlipNext from '../Animation/FlipNext';
import { FTBody, FTHeadline, FTInput } from '../Fuse';
import { AuthBox } from './AuthLayout';
import FuseTextfield from '../FuseControls/FuseTextfield';
import FuseButton from '../FuseControls/FuseButton';
import FuseAlert from '../FuseControls/FuseAlert';
import './ForgotPassword.css';

const block = b.lock('ForgotPassword');

/**
 * @property {ForgotPasswordStore} props.forgotPassword
 */
class ForgotPassword extends Component {
    static propTypes = {
        forgotPassword: ForgotPasswordStore.PropType.isRequired,
    };

    get isSubmitted() {
        return this.props.forgotPassword.apiSubmitState.successCount > 0;
    }

    onSubmit = (event) => {
        event.preventDefault();

        if (this.isSubmitted) {
            this.props.forgotPassword.tryAgain();
        } else {
            this.props.forgotPassword.submit();
        }
    };

    getErrorLabel() {
        if (!this.props.forgotPassword.email.isTouched && !this.props.forgotPassword.email.isValid) {
            return 'Your email address is invalid.';
        }
        return '';
    }

    getRenderAlert() {
        const bodyText = this.getErrorLabel();

        if (bodyText === '') {
            return null;
        }

        return <FuseAlert
            className={block('MarginBottom', { section: 'alert' })}
            type="danger"
            icon="error"
            centerIcon
        >
            <FTInput className={block('AlertText')}>{bodyText}</FTInput>
        </FuseAlert>;
    }

    backLink = <FTInput>
        <a
            className={block('BackToLogin')}
            href="/console"
        >Back to login</a>
    </FTInput>;

    renderForm() {
        const { forgotPassword } = this.props;
        return <Fragment>
            <FTHeadline className={block('MarginBottom')}>
                Forgot Password?
            </FTHeadline>
            <FTBody className={block('MarginBottom', { section: 'textBody' })}>
                We just need your company email address to
                <br />
                send your password reset instructions.
            </FTBody>
            {this.getRenderAlert()}
            <FuseTextfield
                store={forgotPassword.email}
                placeholder="Company email address"
                className={block('MarginBottom', { section: 'textfield' })}
                error={this.getErrorLabel() !== ''}
                type="email"
                name="email"
                autoComplete="email"
                autoFocus
            />
            <FuseButton
                submit
                type={'primary'}
                color={'blue'}
                className={block('MarginBottom')}
                fullWidth
                disabled={forgotPassword.email.isEmpty}
                loading={forgotPassword.apiSubmitState.isLoading}
                onClick={this.onSubmit}
            >Reset Password</FuseButton>
            {this.backLink}
        </Fragment>;
    }

    renderSuccess() {
        return <Fragment>
            <FTHeadline className={block('MarginBottom')}>
                Instructions Sent
            </FTHeadline>
            <FTBody className={block('MarginBottom', { section: 'textBody' })}>
                An email has been sent to
                <br />
                <span className={block('Email')}>{this.props.forgotPassword.email.value}</span>
            </FTBody>

            <FTBody className={block('MarginBottom', { section: 'textBody' })}>
                Please check your email and follow the
                <br />
                instructions to reset your password.
                <br />
                <br />
                <span className={block('bodyTextBottom')}>Haven’t received an email?</span>
            </FTBody>
            <FuseButton
                submit
                type={'primary'}
                color={'blue'}
                className={block('MarginBottom')}
                fullWidth
                onClick={this.onSubmit}
            >Resend</FuseButton>
            {this.backLink}
        </Fragment>;
    }

    render() {
        return <FlipNext flip={this.isSubmitted}>
            <AuthBox
                className={block('Display')}
                onSubmit={this.onSubmit}
            >{this.isSubmitted ? this.renderSuccess() : this.renderForm() }</AuthBox>
        </FlipNext>;
    }
}

export default translate()(inject('forgotPassword')(observer(ForgotPassword)));
